import { definePreset } from '@primeng/themes';
import Material from '@primeng/themes/material';

export const purplePreset = definePreset(Material, {
  semantic: {
    primary: {
      50: '#e6f2f1',
      100: '#b3ddd9',
      200: '#80c8c1',
      300: '#4db3a9',
      400: '#26a094',
      500: 'var(--primeng-primary-color, #005850)', // Dynamic: uses CSS variable
      600: '#004d46',
      700: '#00423c',
      800: '#003732',
      900: '#002b28',
      950: '#001a18'
    },
    colorScheme: {
      light: {
        primary: {
          color: 'var(--primeng-primary-color, #005850)', // Dynamic
          contrastColor: '#ffffff',
          hoverColor: 'var(--primeng-primary-hover, #004d46)', // Dynamic
          activeColor: 'var(--primeng-primary-active, #00423c)' // Dynamic
        },
        formField: {
          hoverBorderColor: '{primary.color}'
        }
      },
      dark: {
        primary: {
          color: '#490E67', // Purple (dark theme)
          contrastColor: '#ffffff',
          hoverColor: '#6a1a8f',
          activeColor: '#3a0b52'
        }
      }
    }
  }
});
